import React, { useState, useCallback, useMemo } from 'react'
import { faCopy, faThumbsUp } from '@fortawesome/pro-regular-svg-icons'
import { L1PlainIconButton } from '../form/l1/L1Button'

export const useClipboardCopy = (data: string|null, onComplete?: () => void) => {
	const [showSuccess, setShowSuccess] = useState(false)
	const handleClick = useCallback(async () => {
		if(!data) {
			return
		}
		try {
			await navigator.clipboard.writeText(data)
			setShowSuccess(true)
			setTimeout(() => {
				setShowSuccess(false)
				if(onComplete) onComplete()
			}, 1000)
		} catch(err) {
			alert(err)
		}
	}, [data, setShowSuccess])
	return useMemo(() => ({
		showSuccess,
		handleClick,
	}), [showSuccess, handleClick])
}

interface L1ClipboardCopyButtonProps {
	showSuccess: boolean
	onClick: React.MouseEventHandler<HTMLButtonElement>
}

export const L1ClipboardCopyButton = ({showSuccess, onClick}: L1ClipboardCopyButtonProps) => {
	return (
		<L1PlainIconButton
			icon={showSuccess ? faThumbsUp : faCopy}
			onClick={onClick}
		/>
	)
}
